<template>
  <section class="section-news-filters">
    <div class="container">
      <div class="news-filter__head">
        <FilterButtons
            :filters="filters"
            :selected="selectedFilter"
            @getSubFilter="subFilter"
            @getSelectedFilter="selectedFilter = $event"/>
      </div>

      <div class="news-filter__body">
        <PostsList :posts="posts" :selectedFilter="selectedFilter" @getLimitPosts="$emit('getLimitPosts')"/>
        <!-- <BannerAd/> -->
      </div>
    </div>
  </section>
</template>

<script>
import FilterButtons from './filterButtons'
import PostsList from './postsList'
import BannerAd from './bannerAd'

export default {
  components: {
    FilterButtons,
    PostsList,
    BannerAd
  },
  methods:{
    subFilter(val){
      this.$emit('getSubFilter',val);
    }
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    posts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getFilter() {
      return this.selectedFilter;
    }
  },
  data: () => ({
    selectedFilter: {}
  })
};
</script>